<template>
  <div>
    <b-breadcrumb :items="$options.breadcrumb"/>
    <b-card-group deck>
      <printer-card v-for="entry in list" :id="entry.id" :key="entry.id"/>
    </b-card-group>
  </div>

</template>

<script>
import PrinterCard from '../../components/PrinterCard';

export default
{
    apollo:
    {
        $subscribe:
        {
            printers:
            {
                query: require('../../graphql/overview.sub.gql'),
                result({data: {printers: { nodes }}})
                {
                    this.list = nodes;
                }
            }
        }
    },
    components: { PrinterCard },
    data()
    {
        return {
            list: []
        }
    },
    breadcrumb:
    [
        { text: 'Rapporten' },
        { text: 'Overzicht', active: true }
    ]
}
</script>

<style scoped>

</style>